// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","2795": "cd87512a8519","5461": "4abfb4091f55","5981": "9200fc8d30ac","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}